import { createRoute } from '@tanstack/react-router'
import { projectRoute } from '../route'
import { InboxPage } from '@/components/inbox/inbox-page'
import { InboxFeatureGate } from '@/components/inbox/feature-gate'
import type { InboxFolder } from '@hub/contracts'

export interface InboxSearchParams {
  email?: string
  folder?: InboxFolder
}

const FOLDERS: InboxFolder[] = ['inbox', 'processed', 'archive']

export const inboxRoute = createRoute({
  getParentRoute: () => projectRoute,
  path: '/inbox/',
  component: InboxRoutePage,
  validateSearch: (search: Record<string, unknown>): InboxSearchParams => ({
    email: typeof search.email === 'string' ? search.email : undefined,
    folder: FOLDERS.includes(search.folder as InboxFolder)
      ? (search.folder as InboxFolder)
      : undefined,
  }),
})

function InboxRoutePage() {
  const { projectId } = inboxRoute.useParams()
  const { email, folder } = inboxRoute.useSearch()
  const navigate = inboxRoute.useNavigate()
  return (
    <InboxFeatureGate projectId={projectId}>
      <InboxPage
        projectId={projectId}
        folder={folder ?? 'inbox'}
        selectedEmailId={email ?? null}
        onChange={(next) =>
          void navigate({
            search: {
              folder: next.folder === 'inbox' ? undefined : next.folder,
              email: next.email ?? undefined,
            },
            replace: true,
          })
        }
      />
    </InboxFeatureGate>
  )
}
